<template>
        <div class="device-list" tabindex="0" role="region" aria-label="已绑定机器ID列表，可上下滚动">
          <button v-for="deviceId in deviceIds" :key="deviceId" class="device-item" type="button" @click="$emit('copy', deviceId)">
            <span class="device-status"></span>
            <span><small>机器 ID</small><strong>{{ deviceId }}</strong></span>
            <em>点击复制</em>
          </button>
        </div>
</template>

<script>
export default {
  name: 'BoundDeviceList',
  props: { deviceIds: { type: Array, default: () => [] } },
  emits: ['copy'],
};
</script>

<style scoped>
.device-list {
  display: grid;
  gap: 10px;
  max-height: 320px;
  overflow-y: auto;
  overscroll-behavior-y: contain;
  scrollbar-gutter: stable;
  padding: 10px 6px 2px 0;
  box-sizing: border-box;
}
.device-list:focus-visible { outline: 2px solid var(--brand); outline-offset: 2px; }
.device-item { display: flex; width: 100%; align-items: center; gap: 12px; padding: 13px 14px; border: 1px solid #e4eded; border-radius: 11px; color: inherit; background: #f9fbfb; text-align: left; cursor: pointer; transition: border-color .2s, background .2s, transform .2s; }
.device-item:hover { border-color: #9dcfc9; background: #f0faf8; transform: translateY(-1px); }
.device-item span:nth-child(2) { display: flex; min-width: 0; flex: 1; flex-direction: column; gap: 4px; }
.device-item small { color: var(--muted); }
.device-item strong { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-family: Consolas, monospace; font-size: 14px; }
.device-item em { color: var(--brand); font-size: 12px; font-style: normal; }
.device-status { width: 8px; height: 8px; flex-shrink: 0; border-radius: 50%; background: #27a76f; box-shadow: 0 0 0 4px #e1f4ea; }

@media (max-width: 680px) {
  .device-list { max-height: 280px; }
  .device-item em { display: none; }
}
</style>
